(function () {
  if (window.medshrumProductAddGuard) return;
  window.medshrumProductAddGuard = true;

  function findProductForm(target) {
    if (!target || !target.closest) return null;
    return target.closest('product-form form[data-cart-submit], product-form form[action*="/cart/add"]');
  }

  function collectLine(form) {
    var data = new FormData(form);
    var id = data.get('id');
    if (!id) return null;

    var quantity = Number(data.get('quantity') || 1) || 1;
    var sellingPlan = data.get('selling_plan');
    var lineProperties = {};

    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) lineProperties[match[1]] = value;
    });

    return { id: id, quantity: quantity, sellingPlan: sellingPlan, properties: lineProperties };
  }

  function afterCartAdd(button) {
    if (window.jQuery) {
      window.jQuery(document).one('cart.requestComplete', function (event, cart) {
        var counter = document.getElementById('counter');
        if (counter && cart && typeof cart.item_count !== 'undefined') {
          counter.setAttribute('data-count', cart.item_count);
        }
        document.body.classList.add('open-cart');
        document.body.classList.add('hideheader');
        if (button) button.classList.remove('loading');
      });
    }
  }

  function fallbackAdd(line, button) {
    var body = { id: line.id, quantity: line.quantity, properties: line.properties };
    if (line.sellingPlan) body.selling_plan = line.sellingPlan;

    window.fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (error) { throw error; });
        return window.fetch('/cart.js', { credentials: 'same-origin' });
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var counter = document.getElementById('counter');
        if (counter && cart && typeof cart.item_count !== 'undefined') {
          counter.setAttribute('data-count', cart.item_count);
        }
        document.body.classList.add('open-cart');
        document.body.classList.add('hideheader');
      })
      .catch(function (error) {
        var message = error && (error.description || error.message);
        if (message) window.alert(message);
      })
      .finally(function () {
        if (button) button.classList.remove('loading');
      });
  }

  function addOnce(form, button) {
    if (!form || form.dataset.medshrumAdding === 'true') return;
    var line = collectLine(form);
    if (!line) return;

    form.dataset.medshrumAdding = 'true';
    window.setTimeout(function () { delete form.dataset.medshrumAdding; }, 1500);
    if (button) button.classList.add('loading');

    if (window.CartJS && window.CartJS.addItem) {
      var cartData = {};
      Object.keys(line.properties).forEach(function (key) { cartData[key] = line.properties[key]; });
      if (line.sellingPlan) cartData.selling_plan = line.sellingPlan;
      afterCartAdd(button);
      window.CartJS.addItem(line.id, line.quantity, cartData);
      return;
    }

    fallbackAdd(line, button);
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('button[type="submit"], button[name="add"], input[type="submit"]');
    if (!button) return;
    var form = findProductForm(button);
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addOnce(form, button);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = findProductForm(event.target);
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addOnce(form, form.querySelector('button[type="submit"], button[name="add"], input[type="submit"]'));
  }, true);
})();

document.addEventListener('click', function(e) {
    const cartSection = document.querySelector('section.cart');
    const cartToggle = document.querySelector('button[aria-label="Bag"]');

    const searchDrawer = document.querySelector('#searchbar');
    const searchToggle = document.querySelector('a.fire-search');
    
    // Ignore clicks on the cart itself or the toggle button
    if (cartSection && cartToggle && !cartSection.contains(e.target) && !cartToggle.contains(e.target)) {
      document.body.classList.remove('open-cart');
    }

    if (searchDrawer && searchToggle && !searchDrawer.contains(e.target) && !searchToggle.contains(e.target)) {
      document.body.classList.remove('open-search');
    }
});